import { Platform, useWindowDimensions } from 'react-native';

const DESKTOP_MIN_WIDTH = 1100;

export default function useDesktopLayout() {
  const { width } = useWindowDimensions();
  return Platform.OS === 'web' && width >= DESKTOP_MIN_WIDTH;
}
